<template>
  <component :is="currentComponent"></component>
</template>

<script>
import FacialHarmonizationContentEn from './FacialHarmonizationContent/FacialHarmonizationContentEn.vue';
import FacialHarmonizationContentPtBR from './FacialHarmonizationContent/FacialHarmonizationContentPtBR.vue';
import FacialHarmonizationContentEs from './FacialHarmonizationContent/FacialHarmonizationContentEs.vue';
import { LANGUAGES } from '@/common/constants';
export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return FacialHarmonizationContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return FacialHarmonizationContentEs;
      }
      return FacialHarmonizationContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
